import React, { Component } from 'react';
import { connect } from 'react-redux';
import throttle from 'lodash/throttle';
import Axios from 'axios';
import Helmet from 'react-helmet';

import UpcomingEvents from '@/components/organisms/UpcomingEvents';
import Hero from '@/components/Hero';
import Newsletter from '@/components/_common/Newsletter';
import BookCta from '@/components/_common/BookCta';
import MetaDetail from '@/components/_common/MetaDetail';
import tracking from '@/utils/tracking';
import FeaturedArticles from './FeaturedArticles';
import Details from './Details';

import { buildContentAction } from '@/services/content/actions';
import { showHeaderLogo, hideHeaderLogo } from '@/services/ui/logo/actions';


import { IMAGE, HEADER_COPY } from '@/utils/content-keys';

import './home.scss';

class HomePage extends Component {
	state = { logoVisible: true };
	logoRef = null;
	throttledScroll = null;
	moduleNames = [
		{ name: 'Hero module', title: 'Hero' },
		{ name: 'Overview module', title: 'FeaturedArticles' },
		// { name: "Latest beers on tap module", title: "LatestBeers" },
		{ name: 'Upcoming events module', title: 'UpcomingEvents' },
		{ name: 'Opening times module', title: 'Opening' },
		{ name: 'Newsletter sign-up module', title: 'Newsletter' },
		{ name: 'BOOK module (for mobile)', title: 'Book' }
	];

	componentDidMount() {
		tracking.pageView('/');

		if (!this.props.data.fetchedData) {
			this.props.fetchData(
				{ name: 'homePage', modules: this.moduleNames, transform: true },
				true,
				'HOMEPAGE'
			);
		}
		else if (!this.props.data.built && this.props.data.data) {
			this.props.buildContentAction(this.props.data.data, {
				name: 'homePage',
				modules: this.moduleNames,
				transform: true
			});
		}
		else {
			console.log('HomePage - data fetched');
		}

		this.throttledScroll = throttle(this.onScroll, 100);
		window.addEventListener('scroll', this.throttledScroll);
		this.onScroll();
	}

	onScroll = () => {
		if (!this.logoRef) {
			return;
		}

		const logoPos =
			this.logoRef.getBoundingClientRect().y ||
			this.logoRef.getBoundingClientRect().top;

		if (logoPos < 0) {
			this.setState({ logoVisible: false });
			this.props.showHeaderLogo();
		}
		else if (logoPos >= 0) {
			this.setState({ logoVisible: true });
			this.props.hideHeaderLogo();
		}
	};

	componentWillUnmount() {
		window.removeEventListener('scroll', this.throttledScroll);
	}

	getMeta() {
		const baseURL = window.location.hostname !== 'localhost' ? window.location.hostname : 'www.guinnessopengate.com';
		Axios.get(`https://cms.diageohorizon.com/PR1515/${baseURL}/en-gb/HOMEPAGE.json?v=${Math.random()}`)
			.then(res => {
				for (let field of res.data.contents[0].fields) {
					if (field.id === 'metadata') {
						let title = '';
						let description = '';
						for (let metafield of field.fields) {
							if (metafield.id === 'metatitle') {
								title = metafield.value;
								continue;
							}
							else if (metafield.id === 'metadescription') {
								description = metafield.value;
								continue;
							}
						}
						this.setState({
							metaTitle: title,
							metaDesc: description
						});
					}
				}
			});
	}

	render() {
		if (!this.props.data || !this.props.data.contents) {
			return;
		}

		const { componentData } = this.props;
		const { contents } = this.props.data;
		let metaState = {};

		if (!this.state.metaTitle) {
			this.getMeta();
		}
		else {
			metaState = {
				title: this.state.metaTitle,
				description: this.state.metaDesc
			};
		}

		metaState.canonical = window.location.href;

		return (
			<div role="main" aria-label="Home Page" className="HomePage">
				<MetaDetail meta={metaState} />
				<Helmet>
					<meta name="google-site-verification" content="R354152QlB27n3zvsihcV8odT9TX11hZbxDurS9Oado" />
				</Helmet>
				<Hero
					imageSource={contents.Hero[2][IMAGE].imgURL}
					srcSet={`${contents.Hero[1][IMAGE].imgURL} 750w, ${
						contents.Hero[2][IMAGE].imgURL
					} 1984w`}
					className="Hero--home"
					fullWidth
					alt={contents.Hero[2][IMAGE].alternateText}
				>
					<div className="Hero-home__content-wrapper">
						<img
							className={`Hero-home__logo ${
								this.state.logoVisible ? 'Hero-home__logo--visible' : ''
							}`}
							src={contents.Hero[0][IMAGE].imgURL}
							alt="Open Gate Brewery"
							ref={el => {
								if (!this.logoRef && el) {
									this.logoRef = el;
								}
							}}
						/>
						<h1 className="Hero-home__headline">
							{contents.Hero[0][HEADER_COPY].value}
						</h1>
					</div>
				</Hero>
				<FeaturedArticles items={contents.FeaturedArticles} />
				{/* <UpcomingEvents
					routeProps={this.props.routeProps}
					dataKey="Data__Events"
				/> */}
				<Details content={contents.Opening[0]} />
				<Newsletter
					content={contents.Newsletter[0]}
					formData={componentData.signUpForm}
					fetchData={this.props.fetchData}
					routeProps={this.props.routeProps}
				/>
				{/* <BookCta
					link={contents.Book[0]["CTA LINK"].value}
					label={contents.Book[0]["CTA COPY"].value}
					path={contents.Book[0]["CTA LINK"].value}
					routeProps={this.props.routeProps}
				/> */}
			</div>
		);
	}
}

export default connect(
	() => ({}),
	{ buildContentAction, showHeaderLogo, hideHeaderLogo }
)(HomePage);



// WEBPACK FOOTER //
// ./src/pages/home/index.js